import SARIcon from './SARIcon';

interface SARProps {
  amount: number;
  className?: string;
  iconSize?: number;
}

/** يعرض مبلغاً منسّقاً مع رمز الريال السعودي الرسمي */
const SAR = ({ amount, className = '', iconSize = 13 }: SARProps) => {
  const formatted = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(amount);
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      {formatted}
      <SARIcon size={iconSize} />
    </span>
  );
};

export default SAR;
